import React from 'react';
import { HiOutlineSparkles, HiOutlineBeaker, HiOutlineLightningBolt } from 'react-icons/hi';
import Typewriter from 'typewriter-effect';
import {
  HeroSectionWrapper,
  HeroGrid,
  HeroBadge,
  Title,
  Accent,
  Description,
  HeroActions,
  PrimaryButton,
  SecondaryButton,
  MediaColumn,
  PhotoShell,
  AccentOrbit,
  PhotoInner,
  PhotoImage,
  PhotoOverlay,
  StatusCard,
  StatusHeadline,
  StatusSub,
  StatGrid,
  StatCard,
  StatValue,
  StatLabel,
  TypeLoop,
  Highlights,
  HighlightItem,
  HighlightIcon,
  HighlightContent,
  HighlightTitle,
  HighlightMeta,
} from './HeroStyle';
import furquan6 from '../../images/furquan6.png';
import { Bio } from '../../data/constants';

const stats = [
  { value: '3+', label: 'Years crafting AI products' },
  { value: '25+', label: 'Cross-domain projects shipped' },
  { value: '10+', label: 'Certifications & accolades' },
];

const focusAreas = [
  {
    icon: <HiOutlineSparkles />,
    title: 'GenAI strategy & orchestration',
    meta: 'Architecting RAG systems, eval frameworks, policy guardrails.',
  },
  {
    icon: <HiOutlineBeaker />,
    title: 'Applied research to production',
    meta: 'Translating prototypes into dependable ML services.',
  },
  {
    icon: <HiOutlineLightningBolt />,
    title: 'Experience-minded engineering',
    meta: 'Partnering with product teams to ship measurable impact.',
  },
  {
    icon: <HiOutlineSparkles />,
    title: 'Graduated with distinction',
    meta: 'Osmania University · B.E. CSE (AI & ML)',
  },
];

const primaryHighlights = focusAreas.slice(0, 2);
const secondaryHighlights = focusAreas.slice(2);

const availability = {
  headline: 'Available for advisory sprints',
  detail: 'GMT+5:30 · Remote-friendly',
};

const HeroSection = () => (
  <HeroSectionWrapper id="about">
    <HeroGrid>
      <div>
        <HeroBadge>AI/ML Engineer</HeroBadge>
        <Title>
          Designing intelligent systems that feel <Accent>trustworthy</Accent> and{' '}
          <Accent>tailored</Accent>
        </Title>
        <TypeLoop>
          <span>Currently shipping as </span>
          <Accent>
            <Typewriter options={{ strings: Bio.roles, autoStart: true, loop: true }} />
          </Accent>
        </TypeLoop>
        <Description>
          I lead AI and data initiatives at CodexAR, pairing rigorous experimentation
          with product intuition to move ideas from proof-of-concept to dependable platforms. My
          work spans LLM tooling, automation, and full-stack experiences that keep humans in the
          loop.
        </Description>
        <Highlights className="primary">
          {primaryHighlights.map(({ icon, title, meta }) => (
            <HighlightItem key={title}>
              <HighlightIcon>{icon}</HighlightIcon>
              <HighlightContent>
                <HighlightTitle>{title}</HighlightTitle>
                <HighlightMeta>{meta}</HighlightMeta>
              </HighlightContent>
            </HighlightItem>
          ))}
        </Highlights>
        <Highlights className="mobile-secondary">
          {secondaryHighlights.map(({ icon, title, meta }) => (
            <HighlightItem key={title}>
              <HighlightIcon>{icon}</HighlightIcon>
              <HighlightContent>
                <HighlightTitle>{title}</HighlightTitle>
                <HighlightMeta>{meta}</HighlightMeta>
              </HighlightContent>
            </HighlightItem>
          ))}
        </Highlights>
        <HeroActions>
          <PrimaryButton href={Bio.resume} target="_blank" rel="noreferrer">
            View Resume
          </PrimaryButton>
          <SecondaryButton to="/contact">Plan a project</SecondaryButton>
        </HeroActions>
      </div>
      <MediaColumn>
        <PhotoShell>
          <AccentOrbit />
          <PhotoInner>
            <PhotoImage src={furquan6} alt="Mohammed Furquan Saleem" />
            <PhotoOverlay />
            <StatusCard>
              <StatusHeadline>{availability.headline}</StatusHeadline>
              <StatusSub>{availability.detail}</StatusSub>
            </StatusCard>
          </PhotoInner>
        </PhotoShell>
        <StatGrid>
          {stats.map((stat) => (
            <StatCard key={stat.label}>
              <StatValue>{stat.value}</StatValue>
              <StatLabel>{stat.label}</StatLabel>
            </StatCard>
          ))}
        </StatGrid>
        <Highlights className="desktop-secondary">
          {secondaryHighlights.map(({ icon, title, meta }) => (
            <HighlightItem key={title}>
              <HighlightIcon>{icon}</HighlightIcon>
              <HighlightContent>
                <HighlightTitle>{title}</HighlightTitle>
                <HighlightMeta>{meta}</HighlightMeta>
              </HighlightContent>
            </HighlightItem>
          ))}
        </Highlights>
      </MediaColumn>
    </HeroGrid>
  </HeroSectionWrapper>
);

export default HeroSection;